import React from "react";
import { CreateOrEditSubscriptionPage } from "./CreateOrEditSubscriptionPage";
export function CreateSubscriptionPage() {
    return <CreateOrEditSubscriptionPage create/>;
}
